/** Create/Edit dialog for Places (content fields + coordinates + cover image). */
import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import {
	Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from '@/components/ui/dialog';
import { CoverUpload } from '@/components/media/Cover';
import { TextField, TextArea } from './_formkit';

const EMPTY = { name: '', category: '', address: '', description: '', lat: '', lng: '', cover_media_id: null };

export function PlaceFormDialog({ open, onOpenChange, initial, onSubmit, pending }) {
	const [f, setF] = useState(EMPTY);
	const isEdit = !!initial;

	useEffect(() => {
		if (!open) return;
		const coords = initial?.location?.coordinates;
		setF(initial ? {
			name: initial.name || '', category: initial.category || '', address: initial.address || '',
			description: initial.description || '',
			lat: coords ? String(coords[1]) : '', lng: coords ? String(coords[0]) : '',
			cover_media_id: initial.cover_media_id || null,
		} : EMPTY);
	}, [open, initial]);

	const set = (k) => (v) => setF((s) => ({ ...s, [k]: v }));

	const submit = (e) => {
		e.preventDefault();
		const body = {
			name: f.name,
			category: f.category || undefined,
			address: f.address || undefined,
			description: f.description || undefined,
			cover_media_id: f.cover_media_id || undefined,
		};
		if (f.lat && f.lng) body.location = { type: 'Point', coordinates: [parseFloat(f.lng), parseFloat(f.lat)] };
		onSubmit(body);
	};

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="bg-slate-900 text-slate-100 border-slate-800 max-h-[90vh] overflow-y-auto">
				<DialogHeader>
					<DialogTitle>{isEdit ? 'Modifica luogo' : 'Nuovo luogo'}</DialogTitle>
					<DialogDescription className="text-slate-400">La pubblicazione si gestisce dai pulsanti dedicati.</DialogDescription>
				</DialogHeader>
				<form onSubmit={submit} className="space-y-3">
					<CoverUpload previewUrl={initial?.cover_url} onChange={set('cover_media_id')} />
					<TextField label="Nome" value={f.name} onChange={set('name')} required data-testid="place-name-input" />
					<div className="grid grid-cols-2 gap-3">
						<TextField label="Categoria" value={f.category} onChange={set('category')} />
						<TextField label="Indirizzo" value={f.address} onChange={set('address')} />
					</div>
					<div className="grid grid-cols-2 gap-3">
						<TextField label="Latitudine" value={f.lat} onChange={set('lat')} placeholder="43.2606" />
						<TextField label="Longitudine" value={f.lng} onChange={set('lng')} placeholder="13.7622" />
					</div>
					<TextArea label="Descrizione" value={f.description} onChange={set('description')} rows={3} />
					<DialogFooter>
						<Button type="submit" disabled={pending} data-testid="place-submit" className="bg-emerald-400 text-slate-950 hover:bg-emerald-300">
							{isEdit ? 'Salva modifiche' : 'Crea'}
						</Button>
					</DialogFooter>
				</form>
			</DialogContent>
		</Dialog>
	);
}
